exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.locationMap {\n  width: 100%;\n  height: 60vh;\n}\n.loadingMarkers {\n  position: absolute;\n  top: 0px;\n  left: 50%;\n  transform: translateX(-50%);\n}\n.locationDetails {\n  min-width:400px;\n  overflow-y: hidden;\n  overflow-x: hidden;\n}\n", ""]);

// exports
